import { Link } from 'react-router-dom';

export default function BadInsuranceSection() {
  const testimonials = [
    {
      name: 'Carlos M.',
      location: 'Campinas/SP',
      type: 'Seguro Automóvel',
      text: 'Depois de um acidente descobri que algumas coberturas importantes não estavam incluídas na minha apólice. Achei que estava protegido, mas tive que arcar com parte do prejuízo.',
      icon: 'ri-car-line'
    },
    {
      name: 'Patrícia R.',
      location: 'Belo Horizonte/MG',
      type: 'Seguro de Vida',
      text: 'Contratei um seguro de vida acreditando que minha família estaria totalmente protegida. Depois percebi que o valor da cobertura era muito menor do que o necessário.',
      icon: 'ri-heart-pulse-line'
    },
    {
      name: 'Ricardo T.',
      location: 'Curitiba/PR',
      type: 'Seguro Empresarial',
      text: 'Quando tivemos um problema na empresa percebemos que várias coberturas essenciais não estavam incluídas na apólice.',
      icon: 'ri-building-line'
    },
    {
      name: 'Empresa Alfa Indústria',
      location: 'São Paulo/SP',
      type: 'Seguro Patrimonial / Incêndio',
      text: 'Após um incidente no galpão descobrimos que algumas coberturas importantes não estavam contratadas. O prejuízo poderia ter sido evitado.',
      icon: 'ri-fire-line'
    },
    {
      name: 'Fernando L.',
      location: 'Rio de Janeiro/RJ',
      type: 'Seguro Automóvel',
      text: 'Descobri depois que estava pagando muito mais caro no meu seguro do que deveria.',
      icon: 'ri-money-dollar-circle-line'
    },
    {
      name: 'Empresa LogTrans',
      location: 'Goiânia/GO',
      type: 'Seguro de Frota',
      text: 'A frota da empresa tinha seguro, mas percebemos que as coberturas não estavam adequadas para o tipo de operação.',
      icon: 'ri-truck-line'
    }
  ];

  const problems = [
    {
      number: '01',
      text: 'Você não sabe quanto está pagando de comissão',
      icon: 'ri-money-dollar-circle-line',
    },
    {
      number: '02',
      text: 'Coberturas mal definidas que não protegem quando importa',
      icon: 'ri-shield-cross-line',
    },
    {
      number: '03',
      text: 'Cláusulas restritivas que passam despercebidas',
      icon: 'ri-file-unknow-line',
    },
    {
      number: '04',
      text: 'Decisões tomadas no escuro, sem análise técnica',
      icon: 'ri-eye-off-line',
    },
  ];

  return (
    <section className="py-16 sm:py-20 lg:py-24 bg-gradient-to-br from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">

        {/* ── HEADER REDESENHADO ── */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center mb-16 sm:mb-20">

          {/* Coluna Esquerda */}
          <div>
            {/* Badge */}
            <div className="inline-flex items-center gap-2 bg-red-50 border border-red-200 px-4 py-2 rounded-full mb-6">
              <i className="ri-alarm-warning-line text-red-600 text-sm"></i>
              <span className="text-red-700 font-bold text-xs uppercase tracking-widest">Alerta de Mercado</span>
            </div>

            {/* Título */}
            <h2
              className="text-3xl sm:text-4xl lg:text-5xl font-bold text-petrol-900 leading-tight mb-5"
              style={{ fontFamily: "'Playfair Display', serif" }}
            >
              Os prejuízos causados por seguros{' '}
              <span className="text-red-600">mal contratados</span>
            </h2>

            {/* Subtítulo */}
            <p className="text-base sm:text-lg text-gray-600 leading-relaxed mb-8">
              Muitos segurados só descobrem os problemas no seguro quando precisam utilizá-lo.
              Quando isso acontece, já é tarde demais para corrigir.
            </p>

            {/* Barra de destaque */}
            <div className="flex items-start gap-3 bg-red-600 rounded-xl px-5 py-4 mb-8">
              <i className="ri-error-warning-line text-white text-xl mt-0.5 flex-shrink-0"></i>
              <p className="text-white text-sm font-semibold leading-snug">
                Contratar seguro não significa necessariamente estar protegido — e a maioria só descobre isso na hora do sinistro.
              </p>
            </div>

            {/* Quote institucional */}
            <div className="border-l-4 border-petrol-700 pl-5">
              <p className="text-base text-gray-700 leading-relaxed italic mb-2">
                "A contratação de seguros envolve análise técnica de riscos, interpretação contratual
                e estratégia de negociação. Sem esse conhecimento, o segurado fica em desvantagem."
              </p>
              <span className="text-xs font-bold text-petrol-700 uppercase tracking-wider">IBX Brasil — Assessoria Técnica em Seguros</span>
            </div>
          </div>

          {/* Coluna Direita — Cards de Problema */}
          <div className="flex flex-col gap-4">
            {/* Intro dos cards */}
            <p className="text-xs font-bold text-gray-400 uppercase tracking-widest mb-1">
              O que acontece quando o seguro falha:
            </p>

            {problems.map((p, i) => (
              <div
                key={i}
                className="flex items-center gap-4 bg-white rounded-xl border border-gray-100 px-5 py-4 hover:border-red-200 hover:shadow-md transition-all duration-200 cursor-default"
              >
                {/* Número */}
                <span
                  className="text-3xl font-bold text-red-100 leading-none select-none flex-shrink-0 w-10 text-center"
                  style={{ fontFamily: "'Playfair Display', serif" }}
                >
                  {p.number}
                </span>
                {/* Ícone */}
                <div className="w-10 h-10 flex items-center justify-center bg-red-50 rounded-lg flex-shrink-0">
                  <i className={`${p.icon} text-lg text-red-500`}></i>
                </div>
                {/* Texto */}
                <p className="text-sm font-medium text-petrol-900 leading-snug">{p.text}</p>
              </div>
            ))}

            {/* Stat de fechamento */}
            <div className="mt-2 bg-gradient-to-r from-petrol-800 to-petrol-900 rounded-xl px-5 py-5 flex items-center gap-4">
              <div className="flex-shrink-0 text-center">
                <span className="block text-3xl font-bold text-white" style={{ fontFamily: "'Playfair Display', serif" }}>90%</span>
                <span className="text-xs text-gray-400 font-medium leading-tight block mt-0.5">dos casos</span>
              </div>
              <div className="w-px h-10 bg-white/20 flex-shrink-0"></div>
              <p className="text-sm text-gray-300 leading-relaxed">
                dos prejuízos com seguros mal contratados são <strong className="text-white">evitáveis</strong> com assessoria técnica especializada.
              </p>
            </div>
          </div>
        </div>
        {/* ── FIM HEADER ── */}

        {/* Testimonials Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-10 sm:mb-12">
          {testimonials.map((testimonial, index) => (
            <div
              key={index}
              className="bg-white rounded-xl shadow-md hover:shadow-xl transition-all duration-300 p-6 border border-gray-100 hover:border-petrol-200"
            >
              <div className="flex items-start gap-4 mb-4">
                <div className="w-12 h-12 bg-gradient-to-br from-petrol-500 to-petrol-700 rounded-lg flex items-center justify-center flex-shrink-0">
                  <i className={`${testimonial.icon} text-2xl text-white`}></i>
                </div>
                <div className="flex-1 min-w-0">
                  <h3 className="text-base font-bold text-petrol-900 mb-1 truncate">
                    {testimonial.name}
                  </h3>
                  <p className="text-xs text-gray-500 mb-1">{testimonial.location}</p>
                  <span className="inline-block px-3 py-1 bg-petrol-50 text-petrol-700 text-xs font-medium rounded-full">
                    {testimonial.type}
                  </span>
                </div>
              </div>
              <p className="text-sm text-gray-700 leading-relaxed italic">
                "{testimonial.text}"
              </p>
            </div>
          ))}
        </div>

        {/* CTA Button */}
        <div className="text-center">
          <Link
            to="/seguros-mal-contratados"
            className="inline-flex items-center gap-3 bg-action-orange-500 text-white px-8 py-4 rounded-xl text-base font-semibold hover:bg-action-orange-600 transition-all shadow-lg hover:shadow-xl hover:scale-105 cursor-pointer whitespace-nowrap"
          >
            <i className="ri-alert-line text-xl"></i>
            Ver os erros mais comuns na contratação de seguros
            <i className="ri-arrow-right-line text-xl"></i>
          </Link>
        </div>

      </div>
    </section>
  );
}